var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect, _circle, _circle2, _circle3, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 149,
    viewBox: "0 0 189 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.468 118.541H82.8516V145.008H106.468V118.541Z",
    fill: "#E7E5E7",
    stroke: "#676977",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.571 135.318H106.468L83.1606 134.103V126.614L91.1701 126.936C91.1701 126.936 102.532 127.096 106.365 127.096",
    fill: "#868586"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.696 142.497L65.6197 142.371C65.5354 142.367 65.453 142.396 65.3892 142.452C65.3255 142.507 65.2852 142.585 65.2765 142.669V147.37C65.275 147.439 65.2872 147.508 65.3124 147.571C65.3375 147.635 65.3752 147.694 65.4232 147.743C65.4712 147.792 65.5284 147.831 65.5917 147.858C65.6549 147.884 65.7228 147.898 65.7914 147.898H84.5794C81.8905 146.797 81.9134 144.458 81.696 142.497Z",
    fill: "#DD5D27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.365 118.541H82.748V145.008H106.365V118.541Z",
    stroke: "#666877",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.693 142.027H65.9405C65.3275 142.027 64.8306 142.525 64.8306 143.139V147.279C64.8306 147.893 65.3275 148.391 65.9405 148.391H122.693C123.306 148.391 123.803 147.893 123.803 147.279V143.139C123.803 142.525 123.306 142.027 122.693 142.027Z",
    fill: "#D6D5D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0127 143.712L123.219 145.788V148.494L65.0241 147.978L65.0127 143.712Z",
    fill: "#E7E5EA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.682 141.809H65.9287C65.3158 141.809 64.8188 142.307 64.8188 142.921V147.061C64.8188 147.675 65.3158 148.173 65.9287 148.173H122.682C123.295 148.173 123.792 147.675 123.792 147.061V142.921C123.792 142.307 123.295 141.809 122.682 141.809Z",
    fill: "#E7E5EA",
    stroke: "#666877",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.581 1H6.06298C3.352 1 1.1543 3.20253 1.1543 5.91951V122.222C1.1543 124.939 3.352 127.142 6.06298 127.142H182.581C185.292 127.142 187.489 124.939 187.489 122.222V5.91951C187.489 3.20253 185.292 1 182.581 1Z",
    fill: "#E7E5E7",
    stroke: "#676977",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179.629 5.01361H8.72939C6.80832 5.01361 5.25098 6.57437 5.25098 8.49969V112.223C5.25098 114.148 6.80832 115.709 8.72939 115.709H179.629C181.55 115.709 183.107 114.148 183.107 112.223V8.49969C183.107 6.57437 181.55 5.01361 179.629 5.01361Z",
    fill: "#D6D5D4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M179.263 7.80017H9.43916C8.90834 7.80017 8.47803 8.2314 8.47803 8.7634V111.558C8.47803 112.09 8.90834 112.521 9.43916 112.521H179.263C179.794 112.521 180.224 112.09 180.224 111.558V8.7634C180.224 8.2314 179.794 7.80017 179.263 7.80017Z",
    fill: "white",
    stroke: "#666877",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M179.64 7.80017H7.59644C7.26784 7.80017 7.00146 8.0671 7.00146 8.39643V12.2036C7.00146 12.533 7.26784 12.8 7.59644 12.8H179.64C179.969 12.8 180.235 12.533 180.235 12.2036V8.39643C180.235 8.0671 179.969 7.80017 179.64 7.80017Z",
    fill: "#B0C5CF"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.378 121.408H144.09C143.936 121.388 143.795 121.312 143.693 121.194C143.591 121.077 143.535 120.927 143.535 120.772C143.535 120.616 143.591 120.466 143.693 120.349C143.795 120.232 143.936 120.156 144.09 120.135H146.378C146.469 120.123 146.561 120.13 146.649 120.157C146.736 120.183 146.817 120.228 146.886 120.288C146.954 120.349 147.01 120.423 147.047 120.506C147.085 120.59 147.105 120.68 147.105 120.772C147.105 120.863 147.085 120.954 147.047 121.037C147.01 121.121 146.954 121.195 146.886 121.255C146.817 121.315 146.736 121.36 146.649 121.387C146.561 121.413 146.469 121.42 146.378 121.408Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.236 121.408H149.948C149.794 121.388 149.653 121.312 149.551 121.194C149.449 121.077 149.393 120.927 149.393 120.772C149.393 120.616 149.449 120.466 149.551 120.349C149.653 120.232 149.794 120.156 149.948 120.135H152.236C152.327 120.123 152.419 120.13 152.506 120.157C152.594 120.183 152.675 120.228 152.744 120.288C152.812 120.349 152.867 120.423 152.905 120.506C152.943 120.59 152.963 120.68 152.963 120.772C152.963 120.863 152.943 120.954 152.905 121.037C152.867 121.121 152.812 121.195 152.744 121.255C152.675 121.315 152.594 121.36 152.506 121.387C152.419 121.413 152.327 121.42 152.236 121.408Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M158.164 121.408H155.875C155.785 121.42 155.692 121.413 155.605 121.387C155.518 121.36 155.437 121.315 155.368 121.255C155.299 121.195 155.244 121.121 155.206 121.037C155.168 120.954 155.149 120.863 155.149 120.772C155.149 120.68 155.168 120.59 155.206 120.506C155.244 120.423 155.299 120.349 155.368 120.288C155.437 120.228 155.518 120.183 155.605 120.157C155.692 120.13 155.785 120.123 155.875 120.135H158.164C158.317 120.156 158.458 120.232 158.56 120.349C158.663 120.466 158.719 120.616 158.719 120.772C158.719 120.927 158.663 121.077 158.56 121.194C158.458 121.312 158.317 121.388 158.164 121.408Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M163.965 121.408H161.676C161.586 121.42 161.494 121.413 161.406 121.387C161.319 121.36 161.238 121.315 161.169 121.255C161.1 121.195 161.045 121.121 161.007 121.037C160.97 120.954 160.95 120.863 160.95 120.772C160.95 120.68 160.97 120.59 161.007 120.506C161.045 120.423 161.1 120.349 161.169 120.288C161.238 120.228 161.319 120.183 161.406 120.157C161.494 120.13 161.586 120.123 161.676 120.135H163.965C164.119 120.156 164.26 120.232 164.362 120.349C164.464 120.466 164.52 120.616 164.52 120.772C164.52 120.927 164.464 121.077 164.362 121.194C164.26 121.312 164.119 121.388 163.965 121.408Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M179.274 7.80017H8.52315C7.99232 7.80017 7.56201 8.2314 7.56201 8.7634V111.558C7.56201 112.09 7.99232 112.521 8.52315 112.521H179.274C179.805 112.521 180.235 112.09 180.235 111.558V8.7634C180.235 8.2314 179.805 7.80017 179.274 7.80017Z",
    stroke: "#666877",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M178.56 7.28607H9.94064C9.41359 7.28607 8.98633 7.35922 8.98633 7.44946V24.886C8.98633 24.9762 9.41359 25.0494 9.94064 25.0494H178.56C179.087 25.0494 179.514 24.9762 179.514 24.886V7.44946C179.514 7.35922 179.087 7.28607 178.56 7.28607Z",
    fill: "#FF9751",
    stroke: "#666877",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.8423,
    y: 12.6151,
    width: 124.343,
    height: 7.10532,
    fill: "#FAFAFA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8681,
    cy: 16.1677,
    r: 3.55266,
    fill: "#D92B2B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5263,
    cy: 16.1677,
    r: 3.55266,
    fill: "#FFDB4D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.184,
    cy: 16.1677,
    r: 3.55266,
    fill: "#9EE69A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9215 80.1156C89.6871 80.1156 90.3924 79.6211 90.6233 78.8517L101.281 43.323C101.562 42.384 101.029 41.3951 100.089 41.113C99.1443 40.8274 98.1585 41.3647 97.8778 42.3037L87.2198 77.8307C86.9392 78.7679 87.4721 79.7604 88.4117 80.0424C88.5823 80.0924 88.7528 80.1156 88.9215 80.1156ZM84.8502 70.7139C84.5038 71.0602 84.0491 71.2334 83.5943 71.2334C83.1396 71.2334 82.6849 71.0602 82.3385 70.7139L73.455 61.8348C73.1229 61.5028 72.9346 61.0512 72.9346 60.5799C72.9346 60.1104 73.1229 59.657 73.455 59.3232L82.3385 50.4388C83.033 49.7444 84.1557 49.7444 84.8502 50.4388C85.5447 51.1314 85.5447 52.256 84.8502 52.9504L77.2226 60.5799L84.8502 68.2005C85.5447 68.8931 85.5447 70.0195 84.8502 70.7139ZM115.046 61.8281L106.163 70.7143C105.816 71.0607 105.361 71.2338 104.907 71.2338C104.452 71.2338 103.997 71.0607 103.651 70.7143C102.956 70.0199 102.956 68.8953 103.651 68.2027L111.278 60.5714L103.651 52.9508C102.956 52.2582 102.956 51.1318 103.651 50.4374C104.345 49.7448 105.468 49.7448 106.163 50.4374L115.046 59.3165C115.38 59.6503 115.567 60.1002 115.567 60.5714C115.567 61.0427 115.38 61.4961 115.046 61.8281Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/Computer.e54de80cbe47abac7e27f99ba4adfcbb.svg";
export { ForwardRef as ReactComponent };